import React from "react";
import { Route, Link } from "react-router-dom";

class ActualLink extends Link {
  render() {
    const {
      as = "a",
      isActive,
      className,
      activeClassName = "active",
      ...props
    } = this.props;
    delete props.replace;
    const Element = as;
    return (
      <Element
        {...props}
        className={`${className} ${isActive && activeClassName}`}
        as="span"
        onClick={this.handleClick}
      />
    );
  }
}

const CustomLink = props => {
  const { to, activeOnlyWhenExact, ...rest } = props;
  const path = typeof to === "object" ? to.pathname : to;
  return (
    <Route
      path={path}
      exact={activeOnlyWhenExact}
      children={props => {
        return <ActualLink isActive={props.match} to={to} {...rest} />;
      }}
    />
  );
};

export default CustomLink;



// WEBPACK FOOTER //
// ./src/app/CustomLink.js